import { VideoSettings, Provider } from '../types/video';

const STORAGE_KEY = 'vidgentf-preferences';

export interface UserPreferences {
  provider?: Provider;
  quality?: 'fast' | 'quality';
  settings?: VideoSettings;
}

const DEFAULT_PREFERENCES: UserPreferences = {
  provider: undefined, // Will auto-detect
  quality: 'fast',
  settings: {
    cameraAngle: 'dashboard',
    weather: 'zonnig',
    timeOfDay: 'overdag',
    style: 'realistisch',
    durationSeconds: 15,
    aspectRatio: '9:16',
  },
};

export function savePreferences(preferences: Partial<UserPreferences>): void {
  try {
    const existing = loadPreferences();
    const updated = { ...existing, ...preferences };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch (error) {
    console.error('Failed to save preferences to localStorage:', error);
  }
}

export function loadPreferences(): UserPreferences {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      return DEFAULT_PREFERENCES;
    }
    const parsed = JSON.parse(stored);
    return { ...DEFAULT_PREFERENCES, ...parsed };
  } catch (error) {
    console.error('Failed to load preferences from localStorage:', error);
    return DEFAULT_PREFERENCES;
  }
}

export function resetPreferences(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('Failed to reset preferences:', error);
  }
}

export function getDefaultSettings(): VideoSettings {
  return DEFAULT_PREFERENCES.settings!;
}
